module.exports = __webpack_public_path__ + "static/img/landing-image-mobile-01.846076b6.jpg";